var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9763 2.5H7.49996C5.92861 2.5 5.14294 2.5 4.65478 2.98816C4.16663 3.47631 4.16663 4.26198 4.16663 5.83333V14.1667C4.16663 15.738 4.16663 16.5237 4.65478 17.0118C5.14294 17.5 5.92861 17.5 7.49996 17.5H12.5C14.0713 17.5 14.857 17.5 15.3451 17.0118C15.8333 16.5237 15.8333 15.738 15.8333 14.1667V7.35702C15.8333 7.0164 15.8333 6.84608 15.7699 6.69294C15.7064 6.5398 15.586 6.41937 15.3451 6.17851L12.1548 2.98816C11.9139 2.7473 11.7935 2.62687 11.6404 2.56343C11.4872 2.5 11.3169 2.5 10.9763 2.5Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8333L12.5 10.8333",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.1667L10.8333 14.1667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 2.5V5.83333C10.8334 6.61901 10.8334 7.01184 11.0775 7.25592C11.3215 7.5 11.7144 7.5 12.5 7.5H15.8334",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.eae88174ea8d14daf1e95feab779814b.svg";
export { ForwardRef as ReactComponent };